import * as React from "react";
import { useMode } from "@/providers/ModeProvider";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export function DataModeToggle(): React.ReactElement {
  const { setMode, isLive } = useMode();

  const handleToggle = (checked: boolean) => {
    const newMode = checked ? 'live' : 'demo';
    setMode(newMode);
    
    if (newMode === 'live') {
      toast.success('Switched to Live Mode');
    } else {
      toast.success('Switched to Demo Mode');
    }
  };

  return (
    <div className="flex items-center gap-2 rounded-md border bg-card px-3 py-2">
      <Label htmlFor="data-mode" className="text-xs font-medium cursor-pointer">
        Demo
      </Label>
      <Switch
        id="data-mode"
        checked={isLive}
        onCheckedChange={handleToggle}
        aria-label="Toggle between demo and live data"
      />
      <Label htmlFor="data-mode" className="text-xs font-medium cursor-pointer">
        Live
      </Label>
    </div>
  );
}
